import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/blog.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Newsroom"
				subtitle=""
				breadcrumbText="Newsroom"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}